import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import App from "./App";
import { initObservability } from "./observability";
import { bootstrapTheme } from "./hooks/useTheme";

// Apply the persisted theme attribute before React renders so the first
// paint already uses the correct palette (no flash of wrong theme).
bootstrapTheme();

// Initialise Sentry + PostHog as early as possible so React render errors
// and the first pageview are captured.
initObservability();

const queryClient = new QueryClient();

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  const root = ReactDOM.createRoot(container);
  root.render(app);
}
